import * as React from "react";
import { forwardRef } from "react";
const SvgMail = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.6666 2.66663H1.33325V13.3333H14.6666V2.66663ZM13.3333 5.33329L7.99992 8.66663L2.66659 5.33329V3.99996L7.99992 7.33329L13.3333 3.99996V5.33329Z", fill: "white" }));
const ForwardRef = forwardRef(SvgMail);
export default ForwardRef;
